/**
 * @file app/constants/tracking.js
 */

export const PAGE_TYPES = {
    CUSTOM: "custom",
    LANDING: "landing",
    DETAIL: "detail",
    NOTFOUND: "notfound",
    TOPIC: "topic",
    BLANK: "blank",
    SHOW: "show",
    INDEX: "index",
};

// Tracking for any sections that need a 'custom' tracking type
// Item Format:
//   id: text id of the section (e.g. "homepage")
//   metadata:  any metadata needed for tracking for the given section
//       tracking: values needed for tracking
//           subSection1: Optional content area subsection (e.g. 'world')
//           subSection2: Optional content area subsection
//           subSection3: Optional content area subsection
//           subSection4: Optional content area subsection
//           contentArea: Content area the item belongs to (e.g. 'homepage' or 'news')
//           contenttype: Type of content being tracked (e.g. 'index' or 'story')
//       adHierarchy: XXX Is this needed??

export const CUSTOM_TRACKING = [
    {
        id: "radio/frequency",
        name: "",
        image: "https://i.cbc.ca/1.4066392.1500303304!/fileImage/httpImage/image.jpg_gen/derivatives/16x9_620/cbc-logo-horizontal.jpg",
        priority: null,
        priorityWhenInlined: null,
        metadata: {
            tracking: {
                subSection1: "radio1",
                subSection2: "frequency",
                subSection3: "",
                subSection4: "",
                contentArea: "radio",
                contenttype: "index",
            },
            adHierarchy: "/",
            polopolyDeptName: "",
            polopolyExternalId: "",
            pageTitle: "CBC Radio - Channels &amp; Frequencies",
            pageDescription: "CBC Channels and Frequencies",
        },
    },
];

/**
 * Section data-feature names.
 */

export const DATA_FEATURE_CARD_GRID = "card-grid";
export const DATA_FEATURE_SWIMLANE = "swimlane";
